export default __webpack_public_path__ + "static/media/pp_logo_circle.2f4e0f85.svg";